<template>
  <div>
    <div class="idFind" :class="{active : layer.firstLayer}">
      <div class="title_wrap">
        <h3>개인정보 입력</h3>
        <p class="warn">*필수입력정보입니다.</p>
      </div>
      <form @submit.prevent="submitForm">
        <div class="idFind_context">
          <div class="article require">
            <p>아이디</p><input type="text" v-model="form.id.value" maxlength="21" @blur="blurId()"/>
          </div>
          <div class="article require">
            <p>비밀번호</p><input type="password" v-model="form.password1.value" maxlength="10"/>
          </div>
          <div class="article require">
            <p>비밀번호 확인</p><input type="password" v-model="form.password2.value" maxlength="10" />
          </div>
          <div class="article require">
            <p>이름</p><input type="text" v-model="form.userName.value" maxlength="10"/>
          </div>
          <div class="article require">
            <p>생년월일</p><input type="text" v-model="form.birthDate.value" maxlength="10" @keyup="formatBirthNumber(form.birthDate.value)"/>
          </div>
          <div class="article require">
            <p>전화번호</p><input type="text" v-model="form.tel.value" maxlength="13"/>
          </div>
          <p class="warn"
             v-if="form.id.hasError" v-text="form.id.errorTxt"></p>
        </div>
        <div class="buttonWrap" :class="{visible : form.id.flag}">
          <button type="submit">다음</button>
        </div>
      </form>
    </div>
    <div class="idFind" :class="{active : layer.secondLayer}">
      <div class="notification">
        <p>회원님의 아이디는 </p>
        <p><b id="userId">thanQ123</b> 입니다.</p>
      </div>
        <div class="title_wrap mt-56">
          <h3>개인정보 입력</h3>
          <p class="warn">*필수입력정보입니다.</p>
        </div>
        <form @submit.prevent="submitForm2">
          <div class="idFind_context">
            <div class="article require">
              <p>새 비밀번호 입력</p><input type="password" v-model="form.newPassword.value" maxlength="21"/>
            </div>
            <div class="article require">
              <p>새 비밀번호 확인</p><input type="password" v-model="form.newPasswordConfirm.value" maxlength="30"/>
            </div>
            <p class="suf-warn"
               v-if="form.newPassword.hasError" v-text="form.newPassword.errorTxt"></p>
            <p class="suf-warn"
               v-if="form.newPasswordConfirm.hasError" v-text="form.newPasswordConfirm.errorTxt"></p>
          </div>

          <div class="buttonWrap visible">
            <button type="submit" class="black">비밀번호 찾기</button>
            <button type="button" onclick="location.href='./login'">로그인</button>
           </div>
        </form>
    </div>
  </div>
</template>

<script>

import { changePw, passwordFindUser } from '../api'
import { Dert } from '../assets/js/thanQAlert'

export default {
  data () {
    return {
      layer: {
        firstLayer: true,
        secondLayer: false
      },
      form: {
        id: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        password1: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        password2: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        userName: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        birthDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        tel: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        newPassword: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        newPasswordConfirm: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      }
    }
  },
  methods: {
    blurId () {
      this.form.id.flag = false
      this.checkId()
    },
    checkId () {
      if (this.form.id.flag) return true

      const id = this.form.id.value
      if (id === '') {
        this.form.id.hasError = true
        this.form.id.errorTxt = '아이디를 입력해주세요.'
        return false
      }
      const isEng = /^[A-Za-z0-9+]*$/
      if (!isEng.test(id)) {
        this.form.id.hasError = true
        this.form.id.errorTxt = '영문, 숫자를 사용하여 입력해주세요.'
        return false
      }
      this.form.id.flag = true
      this.form.id.hasError = false
      this.form.id.errorTxt = ''
      return true
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    },
    formatBirthNumber (obj) {
      this.form.birthDate.value = this.formatBirth(obj)
    },
    checkAll () {
      return !!(this.checkId())
    },
    async submitForm () {
      try {
        const userData = {
          id: this.form.id.value,
          password1: this.form.password1.value,
          password2: this.form.password2.value,
          userName: this.form.userName.value,
          birthDate: this.form.birthDate.value,
          tel: this.form.tel.value
        }
        const { data } = await passwordFindUser(userData)
        this.$emit('secondCall')
        this.layer.firstLayer = false
        this.layer.secondLayer = true
        console.log('this.id: ', data)
        document.getElementById('userId').innerHTML = userData.id
      } catch (error) {
        if (!this.checkAll()) {
          Dert().fire({
            // 제목
            title: '입력하신 정보와 일치하는 회원이 없습니다. <br> 다시 한 번 확인해 주세요.',

            // 작동버튼
            showConfirmButton: true,
            confirmButtonText: '확인',
            confirmButtonClass: 'confirmButtonClass',

            preConfirm: () => {
              console.log('error')
              // this.$emit('secondCall')
              // this.layer.firstLayer = false
              // this.layer.secondLayer = true
            }
          })
        }
      } finally {
        this.initForm()
      }
    },
    initForm () {
      this.form.id.value = ''
      this.form.password2.value = ''
      this.form.userName.value = ''
      this.form.birthDate.value = ''
      this.form.tel.value = ''
    },
    async submitForm2 () {
      try {
        const userData = {
          originPassword: this.form.password1.value,
          newPassword: this.form.newPassword.value,
          confirmPassword: this.form.newPasswordConfirm.value
        }
        const { data } = await changePw(userData)
        console.log('어떤정보가 담겼어?', data.response)
        await this.$router.push('/')
      } catch (error) {

      } finally {
        this.initForm2()
      }
    },
    initForm2 () {
      this.form.password1.value = ''
      this.form.password.value = ''
      this.form.newPassword.value = ''
      this.form.newPasswordConfirm.value = ''
      this.form.newPassword.flag = false
      this.form.newPasswordConfirm.flag = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .mt-56 {
    margin-top: 56px;
  }
  .idFind {
    padding: 0 20px;
    margin:37px 0 0 0;
    display:none;
    &.active {
      display:block;
    }
    .notification {
      display:flex;
      margin: 60px 0px 0px 0px;
      flex-wrap:wrap;
      align-content: center;
      text-align: center;

      span.imgWrap {
        display:block;
        width:100%;
        margin:0 0 6px 0;
        img {

        }
      }
      p {
        width:100%;
        color:#fff;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.5;
        text-decoration: none;

        b {
          font-weight: bold;
        }
      }
    }

    .buttonWrap {
      position:absolute;
      bottom:0;
      width:100%;
      color:#fff;
      transition: 0.5s;
      height:0;
      left:0;
      display: flex;
      height:65px;

      &.visible {

      }

      button {
        &.black {
          background:#4b4b4b;
        }
        font-family: "NotoSansCJKkr", serif;
        font-size:14px;
        font-weight:normal;
        line-height:65px;
        width:100%;
        background:transparent;
        border:0;
        height:inherit;
        padding:0;
        margin:0;
        color:#fff;
        background:#ff6565;
      }
    }
    .title_wrap {
      h3 {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.5;
        color: #fff;
        margin: 0px 0px 5px 0px;
      }
    }

    p.warn {
      color: #ff6565;
      font-size: 14px;
      font-weight:normal;
      line-height:1.43;
      margin:0px 0px 9px 0px;
    }

    .idFind_context {
      .wholeCheck {
        cursor: pointer;
      }
      .article {
        background: rgb(158, 158, 158);
        display: flex;
        padding: 10px 18px 11px;
        justify-content: space-between;
        &.onAgree {
          span.imgWrap {
            float: right;

            img {
            }
          }
        }
        &:first-of-type {
        }

        &.require {
          border:0px solid #403f3f;
          border-width:0 0 1px 0;
          position: relative;
          justify-content: normal;
          &:after {
            content: "*";
            color: #ff6565;
            left: 6px;
            position: absolute;
            top: calc(50% - 7px);
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
          }
          input {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color:#403f3f;
            border:0;
            background:transparent;
            outline: none;
            position: absolute;
            width: 335px;
            text-align: center;
            left: 0;
          }
        }

        p {
          font-size:12px;
          font-weight:normal;
          line-height:1.5;
          color: #fff;

          &.warn {
            font-size: 10px;
            font-weight: normal;
            line-height: 1.5;
            color: #ff6565;
          }
        }

        span.imgWrap {
          float: right;

          img {

          }
        }
        span.imgWrap {
          float:right;
          img {

          }
        }
      }
    }
  }

</style>
